// import EntypoIcon from 'react-native-vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUIStoreWebsiteView from 'xui/modules/storeWebsite/BaseUIStoreWebsiteView'

export default class StoreWebsiteView extends BaseUIStoreWebsiteView {}
